/* eslint-disable no-magic-numbers */

export const buttonSizes = [
	'large',
	'compact',
	'min',
] as const;

export type ButtonSize = typeof buttonSizes[number] | LegacyButtonSize;

// Pre-redesign names, kept so existing call sites keep compiling.
// ponytail: delete once no consumer passes them.
type LegacyButtonSize = 'default' | 'small' | 'link';

export type ButtonSizeDefinition = {
	/** Fixed height, and the side of the square an icon-only button becomes. */
	height: number;
	fontSize: number;
	fontWeight: number;
	/** Icon sitting next to a label. Icon-only ignores this — see iconOnlyIconSize. */
	iconSize: number;
	paddingHorizontal: number;
	/** Horizontal padding on the side an icon sits on — tighter than the text side. */
	paddingIcon: number;
	gap: number;
};

// Figma draws icons in 24 / 20 / 16 frames. The rebrand glyphs carry the frame's padding
// themselves (drawn on a 24 grid), so the font size is the frame as is.
// ponytail: kept as a ratio so the old icons' 17.8 / 24 is one edit away if the rebrand is rolled back.
const glyphRatio = 1;

// An icon-only button never shrinks its glyph; the button box shrinks around it,
// down to min where the box is the 24 frame and the glyph fills it.
export const iconOnlyIconSize = 24;

const large: ButtonSizeDefinition = {
	height: 48,
	fontSize: 18,
	fontWeight: 560,
	iconSize: 24 * glyphRatio,
	paddingHorizontal: 22,
	paddingIcon: 20,
	gap: 4,
};

const compact: ButtonSizeDefinition = {
	height: 36,
	fontSize: 14,
	fontWeight: 560,
	iconSize: 20 * glyphRatio,
	paddingHorizontal: 16,
	paddingIcon: 14,
	gap: 4,
};

const min: ButtonSizeDefinition = {
	height: 24,
	fontSize: 12,
	fontWeight: 510,
	iconSize: 16 * glyphRatio,
	paddingHorizontal: 10,
	paddingIcon: 8,
	gap: 4,
};

export const ButtonSizes: {[key in ButtonSize]: ButtonSizeDefinition} = {
	large,
	compact,
	min,
	default: compact,
	small: compact,
	link: min,
};
